module.exports = __webpack_public_path__ + "e616155e0978011bd6970008993ba98f.png";